import React, { useEffect, useState } from "react"

import { Fragment } from "react"
import { navigate } from "@reach/router"
import Event from "../../components/Event"
import Pagination from "../../components/Pagination"
import Layout from "../../components/Layout"
import TitlePage from "../../components/TitlePage"
import Searcher from "../../components/Searcher"
import TopicalityMenu from "../../components/TopicalityPage/TopicalityMenu"
import TitleBlock from "../../components/TitleBlock"
import { searchT } from "../../commons/commons"
import { useAxiosClient } from "../../service/useAxiosClient"
import Hero from "../../components/Hero"
import * as queryString from "query-string"

export default function ActivitySearcher(props) {
  const query = queryString.parse(props.location.search)
  const { category, finish, init, text } = query
  const id = parseInt(category)
  const [activitiesCategories, setActivitiesCategories] = useState([])
  const [lastActivities, setLastActivities] = useState([])
  const [totalPages, setTotalPages] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)

  const [{ data: activitiesCategoriesData }] = useAxiosClient({
    url: `/activities/categories/web/`,
    method: "GET",
  })

  useEffect(() => {
    if (activitiesCategoriesData && activitiesCategoriesData.length) {
      setActivitiesCategories(activitiesCategoriesData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activitiesCategoriesData, id])

  const [{ data: lastActivitiesData }] = useAxiosClient({
    url: `/activities/search/`,
    method: "GET",
    params: {
      page: currentPage,
      category,
      finish,
      init,
      text,
    },
  })

  useEffect(() => {
    if (lastActivitiesData) {
      setLastActivities(lastActivitiesData.items)
      setTotalPages(lastActivitiesData?.total_pages)
    }
  }, [lastActivitiesData, id])

  const renderEvents = () => {
    return (
      lastActivities &&
      lastActivities.map((item, i) => {
        return (
          <Event
            date={item.description_dates_calendar}
            title={item.title}
            path={`/servicios-y-actividades/${item.category.pk}/${item.category.slug}/${item.pk}/${item.slug}`}
            subtitle={item.subtitle}
            key={`event-${i}`}
            colorBorder={item?.category_color}
            id={item?.id}
            categoryPk={id}
          />
        )
      })
    )
  }

  const getPage = page => {
    setCurrentPage(page)
  }

  const renderPagination = () => {
    if (totalPages <= 1) {
      return <div className="WebExam-wrapper">{renderEvents()}</div>
    }

    return (
      <Fragment>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          getPage={getPage}
        />
        <div className="WebExam-wrapper">{renderEvents()}</div>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          getPage={getPage}
        />
      </Fragment>
    )
  }

  const getCategory = data => {
    navigate(`/servicios-y-actividades/${data.pk}/${data.slug}`)
  }

  const handleSearchBar = filters => {
    setCurrentPage(1)
    navigate(`/servicios-y-actividades/buscador/?${searchT(filters)}`, {
      state: { filters: filters },
    })
  }

  return (
    <Layout>
      <TitlePage title="Buscador actividades" url={props.location.pathname} />
      <Hero image="/imgs/servicios-actividades-ret.jpg" text="Buscador" />
      <div className="container950">
        <Searcher
          onChangeFilter={handleSearchBar}
          selectCategory={activitiesCategories}
          defaultValues={query}
        />
        <div className="row efpa-row">
          <div className="col-12 col-md-3 Topicality-padding-col">
            <TopicalityMenu
              list={activitiesCategories}
              showTitle={false}
              className="LayoutTest-options"
              useGalleryItem={false}
              getCategory={getCategory}
              initialCategory={id}
              useAllData
            />
          </div>
          <div className="col-12 col-md-9 Topicality-col-9">
            <TitleBlock
              title="Buscador actividades"
              icon="far fa-calendar-alt"
            />
            {renderPagination()}
          </div>
        </div>
      </div>
    </Layout>
  )
}
